import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { asyncConnect } from 'redux-connect';
import _ from 'lodash';
// import Link from '../../../../../components/ZUILib/Link';
import pdfUtil from '../../../../../utils/PDFUtil';
// import InputButton from '../../../../../components/ZUILib/InputButton';
// import ApplyCSS from '../../../../../components/ApplyCSS';
// import VerificationPanel from './verificationPanel';
import commonUtil from '../../../../../utils/commonUtil';
import { constDownload, constPrint, constSendMail } from '../../../../../utils/clientConstant';
import * as labelsActions from '../../../../../components/labels/actions';
import * as typeActions from '../../actions';
// import ClosingGiftPanel from './ClosingGiftPanel';
import ClosureConfirmationRender from './closureConfirmationRender';
import DownloadPDFWithoutPreview from '../../../../../components/DownloadPDFWithoutPreview';
import AppEvents from '../../../../App/AppEvents';

const applicationRoutes = commonUtil.getApplicationRoutes();
const pageName = 'closureTransference';
const { saveBankOrCardDetails, sendMail } = typeActions;
const { isLablesLoaded, loadLables } = labelsActions;
const channel = commonUtil.getChannel();
// const brand = commonUtil.getBrand();
const constChannels = commonUtil.getClientConstForChannel();


@asyncConnect([{
  promise: ({ store: { dispatch, getState } }) => {
    if (!isLablesLoaded(getState())) {
      return dispatch(loadLables());
    }
    return undefined;
  },
},
])
@connect(store => ({
  content: store.targetterContent.data,
  lables: store.labels.data,
  error: store.labels.error,
  loading: store.labels.loading,
  extraData: store.labels.extraData,
}),
  { labelsActions })

class ClosureConfirmation extends Component {
  constructor(props) {
    super(props);
    this.submitData = null;
    this.submitTransferenceData = null;
    this.accountId = '';
    this.getStatementDetailsForPrintAndDownloadData = null;
    this.state = {
      eWalletCreatedMessage: null,
      savedCardConfirmation: null,
      isGuardar: false,
      emailSendStatus: null,
      employee: null,
    };
  }
  UNSAFE_componentWillMount() {
    if (this.props.location.state && this.props.location.state.submitTransferenceDetails && this.props.location.state.submitTransferenceDetails.message) {
      this.setState({ eWalletCreatedMessage: this.props.location.state.submitTransferenceDetails.message });
    }
    if (this.props.location.state && this.props.location.state.isEmployee) {
      this.setState({ employee: this.props.location.state.isEmployee });
    }
  }
  componentDidMount() {
    if (!this.props.location.state || !this.props.location.state.submitTransferenceDetails) {
      this.redirectToAccountStatment();
    }
    // Browser Back Functionality
    // window.onpopstate = () => {
    //   browserHistory.go(-1);
    //   window.onpopstate = null; // Remove Handler after back is clicked
    // };
    if (channel === constChannels.WAP) {
      this.wapBackButtonEvent = AppEvents.subscribe(AppEvents.EVENT_REGISTER.WAP_BACK_BUTTON_CLICKED);
      if (this.wapBackButtonEvent) {
        AppEvents.publish(this.wapBackButtonEvent, [() => {
          browserHistory.push(commonUtil.routeTo(applicationRoutes.accountStatus, { eventID: this.props.routeParams.eventID }));
        }]);
      }
    }

    commonUtil.clearBrowserHistoryState(commonUtil.getRouteByParameter(applicationRoutes.closureConfirmation, { eventID: this.props.routeParams.eventID }));
  }

  saveCard = () => {
    saveBankOrCardDetails(this.accountId).then((response) => {
      if (response.body.status) {
        if (response.body.status.status === 'success') {
          this.setState({ savedCardConfirmation: response.body.successMessage, isGuardar: true });
        }
      }
    });
  }
  emailSendClick = () => {
    this.setState({ emailSendStatus: null });
  }
  redirectToAccountStatment = () => {
    browserHistory.push(commonUtil.routeTo(applicationRoutes.accountStatus, { eventID: this.props.routeParams.eventID }));
  }
  redirectToAdministration = () => {
    browserHistory.push(commonUtil.getRouteByParameter(applicationRoutes.giftList, { eventID: this.props.routeParams.eventID }));
  }
  getStatementDetailsForDownload = () => {
    this.printDownloadMail(constDownload);
  }
  getStatementDetailsForPrint = () => {
    this.printDownloadMail(constPrint);
  }
  getStatementDetailsForSendMail = () => {
    commonUtil.mailPdf('.toPrint', 'closureConfirmation.pdf', this.accountStatementSendMail);
  }
  accountStatementSendMail = (fileName, data) => {
    const emailId = !commonUtil.isObjectEmpty(this.props.user) && this.props.user.data.result && this.props.user.data.result.emailId;
    sendMail(this.props.routeParams.eventID, fileName, data, emailId).then((res) => {
      pdfUtil.contentDownloadedCallback();
      if (res.body.status === 'success') {
        this.setState({ emailSendStatus: { isSent: true, resMsg: commonUtil.getLabel(this.props.lables.eventAccountStatement, 'accountStatement.emailsent.message') } });
      } else {
        this.setState({ emailSendStatus: { isSent: false, resMsg: commonUtil.getLabel(this.props.lables.eventAccountStatement, 'accountStatement.emailfailed.message') } });
      }
    });
  }
  printDownloadMail = (type) => {
    if (channel === constChannels.WAP) {
      if (type === constDownload) {
        const downloadableContent = (<DownloadPDFWithoutPreview pageName={pageName} printingDate={this.props.printingDate} download>
          <ClosureConfirmationRender submitData={this.submitData} printAndDownload submitTransferenceData={this.submitTransferenceData} user={this.props.user} lables={this.props.lables} getBrandLogoPath={this.getBrandLogoPath} eventID={this.props.routeParams.eventID} redirectToAccountStatment={this.redirectToAccountStatment} redirectToAdministration={this.redirectToAdministration} saveCard={this.saveCard} /></DownloadPDFWithoutPreview>);
        pdfUtil.attachToDom(downloadableContent, ('closureConfirmation_' + this.props.routeParams.eventID));
      } else if (type === constSendMail) {
        const mailContent = (<DownloadPDFWithoutPreview pageName={pageName} printingDate={this.props.printingDate}>
          <ClosureConfirmationRender submitData={this.submitData} printAndDownload submitTransferenceData={this.submitTransferenceData} user={this.props.user} lables={this.props.lables} getBrandLogoPath={this.getBrandLogoPath} eventID={this.props.routeParams.eventID} redirectToAccountStatment={this.redirectToAccountStatment} redirectToAdministration={this.redirectToAdministration} saveCard={this.saveCard} /></DownloadPDFWithoutPreview>);
        pdfUtil.attachToDomForMail(mailContent, 'closureConfirmation', this.accountStatementSendMail);
      }
    } /* eslint-disable */else {
      if (type === constDownload) {
        const downloadableContent = (<DownloadPDFWithoutPreview pageName={pageName} printingDate={this.props.printingDate} download>
          <ClosureConfirmationRender submitData={this.submitData} printAndDownload submitTransferenceData={this.submitTransferenceData} user={this.props.user} lables={this.props.lables} getBrandLogoPath={this.getBrandLogoPath} eventID={this.props.routeParams.eventID} redirectToAccountStatment={this.redirectToAccountStatment} redirectToAdministration={this.redirectToAdministration} saveCard={this.saveCard} /></DownloadPDFWithoutPreview>);
        pdfUtil.attachToDom(downloadableContent, ('closureConfirmation_' + this.props.routeParams.eventID));
      } else if (type === constPrint) {
        const printContent = (<DownloadPDFWithoutPreview pageName={pageName} printingDate={this.props.printingDate}>
          <ClosureConfirmationRender submitData={this.submitData} printAndDownload submitTransferenceData={this.submitTransferenceData} user={this.props.user} lables={this.props.lables} getBrandLogoPath={this.getBrandLogoPath} eventID={this.props.routeParams.eventID} redirectToAccountStatment={this.redirectToAccountStatment} redirectToAdministration={this.redirectToAdministration} saveCard={this.saveCard} /></DownloadPDFWithoutPreview>);
        pdfUtil.attachToDomForPrint(printContent, pageName);
      }
    }/* eslint-enable */
  }
  getBrandLogoPath = (opt) => {
    let path = '';
    switch (opt) {
      case 'LP':
        path = commonUtil.getAssetURL() + '/images/bag-liverpool.png';
        break;
      case 'PB':
        path = commonUtil.getAssetURL() + '/images/logos/logo-pb.png';
        break;
      case 'PBK':
        path = commonUtil.getAssetURL() + '/images/logos/logo-pbk.png';
        break;
      case 'GAP':
        path = commonUtil.getAssetURL() + '/images/logos/logo-gap.png';
        break;
      case 'WLM':
        path = commonUtil.getAssetURL() + '/images/logos/logo-we.png';
        break;
      case 'WS':
        path = commonUtil.getAssetURL() + '/images/logos/logo-ws.png';
        break;
      case 'TRU':
        path = commonUtil.getAssetURL() + '/images/logos/logo-toys.png';
        break;
      default:
        break;
    }
    return path;
  }

  render() {
    if (this.props.location.state && this.props.location.state.submitTransferenceDetails) {
      this.submitData = this.props.location.state.submitTransferenceDetails.transactionStatusObject;
      if (!_.isEmpty(this.submitData.monederoAccountInfo)) {
        if (this.submitData.monederoAccountInfo.walletType) {
          this.accountId = this.submitData.monederoAccountInfo.accountId;
          this.submitTransferenceData = {
            walletNumber: this.submitData.monederoAccountInfo.number,
            walletType: this.submitData.monederoAccountInfo.walletType,
            walletOrEmployeeCardAmount: this.submitData.monederoAccountInfo.transferAmount,
            walletCommissionAmount: this.submitData.monederoAccountInfo.commission,
            totalAmount_View: this.submitData.monederoAccountInfo.totalAmount,
            bonusAmount: this.submitData.monederoAccountInfo.bonusAmount,
            bonusPercentage: this.submitData.monederoAccountInfo.bonusPercentage,
            commissionValue: this.submitData.monederoAccountInfo.commissionPercentage,
            walletUserName: this.submitData.monederoAccountInfo.userName,
          };
        }
      }
      if (!_.isEmpty(this.submitData.bankOrCardInfo)) {
        if (this.submitData.bankOrCardInfo.paymentType) {
          this.accountId = this.submitData.bankOrCardInfo.accountId;
          this.submitTransferenceData = {
            ...this.submitTransferenceData,
            cardNumber: this.submitData.bankOrCardInfo.number,
            paymentType: this.submitData.bankOrCardInfo.paymentType,
            cardOrBankAmount: this.submitData.bankOrCardInfo.transferAmount,
            commissionAmount: this.submitData.bankOrCardInfo.commission,
            totalAmount_CardBank_View: this.submitData.bankOrCardInfo.totalAmount,
            commissionValue_CardBank: this.submitData.bankOrCardInfo.commissionPercentage,
          };
        }
      }
      if (!_.isEmpty(this.submitData.closingGiftDetails)) {
        this.submitTransferenceData = {
          ...this.submitTransferenceData,
          skus: this.submitData.closingGiftDetails,
        };
      }
      this.submitTransferenceData.transferDate = this.submitData.currTime;
    }
    return (
      <React.Fragment>
        <ClosureConfirmationRender
          submitData={this.submitData} submitTransferenceData={this.submitTransferenceData}
          user={this.props.user} lables={this.props.lables} getBrandLogoPath={this.getBrandLogoPath} eventID={this.props.routeParams.eventID}
          redirectToAccountStatment={this.redirectToAccountStatment} redirectToAdministration={this.redirectToAdministration} saveCard={this.saveCard}
          eWalletCreatedMessage={this.state.eWalletCreatedMessage} savedCardConfirmation={this.state.savedCardConfirmation}
          isGuardar={this.state.isGuardar} emailSendStatus={this.state.emailSendStatus} getStatementDetailsForDownload={this.getStatementDetailsForDownload}
          getStatementDetailsForPrint={this.getStatementDetailsForPrint} getStatementDetailsForSendMail={this.getStatementDetailsForSendMail}
          emailSendClick={this.emailSendClick}
          printAndDownload={false}
          isEmployee={this.state.employee}
        />
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => ({
  user: state.user,
  lables: state.labels,
  printingDate: state.info && state.info.data && state.info.data.time,
});
export default connect(mapStateToProps)(ClosureConfirmation);

